import React from 'react'

const Icon = (props) => {
   return (
      <img {...props} alt="de-CH" />
   )
}

export default Icon
